
export const replaceLinksInText = (text, optionalLink) => {
    // Regular expression to match URLs in the text
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text?.split(urlRegex).map((part, index) => {
        if (index % 2 === 0) {
            // This part is not a URL
            return <span key={index}>{part}</span>;
        } else {
            // This part is a URL, render a button for redirection
            const splittedLink = part.split("/")
            const userId = splittedLink[splittedLink.length - 1]
            const newLink = `${optionalLink}/${userId}`
            return (
                <a
                className="red"
                    href={newLink}
                    target="_blank"
                    key={index}
                >
                    View
                </a>
            );
        }
    });
};